/**
 * Texts for Training page
 */
export const trainingPageText = {
    title: 'Koulutus − CamAPS FX',
    titleMeta: 'Tarjoamme maksutonta verkkokoulutusta CamAPS FX -käyttäjille',
    descriptionMeta: 'Cambridge Diabetes Education Programme tarjoaa maksutonta ja sertifioitua verkkokoulutusta tyypin 1 diabetesta sairastaville henkilöille, vanhemmille ja huoltajille, koulujen henkilökunnalle ja terveydenhoidon ammattilaisille.',
    keywords:
        'camaps koulutus, camaps fx koulutus,  ',
        // 'type 1 diabetes, autoimmune disease, hyperglycemia, dexcom g6, type 1 diabetes symptoms, blood sugar monitor, diasend, insulin pump, diabetes type 1, blood glucose monitor, blood sugar, cgm, high blood sugar, type 1 diabetes causes, what is type 1 diabetes, diabetes in children, type 1, diabetes treatment, type 1 diabetes treatment, what is hypoglycemia, hypoglycemia treatment, jdrf, blood glucose meters, glucose monitor, type one diabetes, continuous glucose monitoring, type 1 diabetes in children, diabetes pump, t1d, closed loop system, diabetes machine, diabetic gastroparesis, diabetic hypoglycemia, diasend uk, diabetes 1, blood glucose monitor boots,  ',
    localeMeta: 'fi_fi',

    trainingHeader: 'Sertifioitu koulutus',
    trainingHeader_2: 'Terveydenhuollon ammattilaisille',
    trainingHeader_3: 'Käyttäjäkoulutus',
    trainingHeaderText: 'MAKSUTON CamAPS FX -verkkokoulutus − Cambridge Diabetes Education Programme (CDEP).',
    websiteLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    websiteLinkHeading: 'CDEP-koulutus',
    getTrained: 'Hanki koulutus',

    trainingHeaderIat: "CamAPS FX -koulutus",
    trainingHeaderTextIat: "Suorita välttämätön sovelluksen sisäinen koulutus ennen CamAPS FX -sovelluksen käyttöä.",
    trainingSubHeaderOneIat: "Aloittaminen",
    trainingSubTextOneIat: "Lataa CamAPS FX -sovellus. <br>Luo tili aloittaaksesi koulutuksen.",
    trainingSubHeaderTwoIat: "Tarvitsetko apua sovelluksen asennuksessa?",
    trainingParaTwoStartIat: "Käy meidän",
    trainingParaTwoEndIat: "osiossa saadaksesi ohjeita.",
    websiteLinkHeadingSupportIat: "Tuki",
    trainingSubHeaderThreeIat: "Lisäresurssit",
    animationsYpsoPumpText: "Animaatiot",
    animationsAndText: "ja",
    animationsDanaText: "Animaatiot (Dana-pumppu)",
    animationsFurtherText: "Opi vaihe vaiheelta visuaalisten ohjeiden avulla.",
    webinarsText: "Webinaarit",
    webinarsFurtherText: "Katso asiantuntijoiden vetämiä sessioita sovelluksen käytöstä.",
    websiteAnimationsYpsoPumpLink: "https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm",
    websiteAnimationsDanaLink: "https://www.camdiabtraining.com/view/25/Dana-insulin-pump-users.htm",
    websiteWebinarsLink: "https://www.camdiabtraining.com/view/20/Webinars.htm"

};
